import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <Navigation />
      <div className="content">
        <h1>About the Neo-Assyrian Bas-Relief Atlas</h1>

        <section>
          <h2>Project Overview</h2>
          <p>
            The Neo-Assyrian Bas-Relief Atlas is a comprehensive digital archive dedicated to documenting,
            preserving, and making accessible the remarkable bas-reliefs of the Neo-Assyrian Empire (911-612
            BCE). This project serves as a bridge between ancient artistry and modern scholarship, providing
            researchers, educators, and enthusiasts with detailed information about these important historical
            artifacts.
          </p>
        </section>

        <section>
          <h2>Our Mission</h2>
          <p>
            Our mission is to create a centralized, scholarly resource that documents Neo-Assyrian bas-reliefs
            scattered across museums worldwide. By bringing these artifacts together in a digital space, we aim to
            facilitate research, education, and appreciation of these remarkable historical treasures.
          </p>
        </section>

        <section>
          <h2>Project Goals</h2>
          <ul>
            <li>Document and preserve detailed information about Neo-Assyrian bas-reliefs</li>
            <li>Create a searchable database of relief locations, descriptions, and scholarly references</li>
            <li>Provide high-quality images and detailed metadata for research purposes</li>
            <li>Map the original and current locations of reliefs worldwide</li>
            <li>Foster collaboration between scholars, museums, and researchers</li>
            <li>Make this important cultural heritage accessible to a global audience</li>
          </ul>
        </section>

        <section>
          <h2>Features</h2>
          <p>Our platform offers:</p>
          <ul>
            <li>Comprehensive catalog of Neo-Assyrian bas-reliefs</li>
            <li>Interactive map showing relief locations</li>
            <li>High-resolution images with detailed metadata</li>
            <li>Scholarly references and citations</li>
            <li>Search and filter capabilities</li>
            <li>Contribution system for scholars and researchers</li>
          </ul>
        </section>

        <section className="collaboration-section">
          <h2>Academic Collaboration</h2>
          <p>
            This project is made possible through collaboration with museums, universities, and scholars
            worldwide. We maintain high academic standards while making this valuable information
            accessible to everyone interested in Neo-Assyrian art and history.
          </p>
        </section>

        <section className="join-section">
          <h2>Join Our Effort</h2>
          <p>
            Are you a scholar, researcher, or museum professional? We welcome contributions to our
            growing database.
          </p>
          <Link to="/contribute" className="contribute-button">
            Contribute to the Atlas
          </Link>
        </section>
      </div>

      <footer>
        <p>2024 Bas Relief Atlas - A Digital Archive of Neo-Assyrian Bas-Reliefs</p>
      </footer>
    </div>
  );
};

export default AboutPage; 